module.exports = __webpack_public_path__ + "static/media/logo.ded94b48.png";